import axios from "axios";
import { baseUrl } from "../../utils/sysEnv";
import * as types from '../types'
import { toast } from "react-toastify";
import { axiosHeader } from "../../utils/helper";



// GET ALL clients
export const getUsers = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${baseUrl}/users`, axiosHeader(info.token))
        .then((res) => {
          // console.log(res.data.data)
          dispatch({
            type: types.GET_USERS,
            payload: res.data.data,
          });
          dispatch({ type: types.RESET_LOADING });
        })
        .catch((error) => {
          if (error.response === undefined) {
            // toast.error(error.message);
            //   setError(dispatch, error)
          } else {
            //  toast.error(error.message);
            //   setError(dispatch, error.response.data.error)
          }
        });
    } catch (error) {
       toast.error(error.message);
    }
  };


  // GET ALL clients
export const getUsersByBranch = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${baseUrl}/users/branch`, axiosHeader(info.token))
        .then((res) => {
          dispatch({
            type: types.GET_USERS,
            payload: res.data.data,
          });
          dispatch({ type: types.RESET_LOADING });
        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error(error.message);
            //   setError(dispatch, error)
          } else {
             toast.error(error.message);
            //   setError(dispatch, error.response.data.error)
          }
        });
    } catch (error) {
       toast.error(error.message);
    }
  };

  
export const updateClientUser = info => async (dispatch) => {


    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .put(`${baseUrl}/users/update`, info, axiosHeader(info.token))
        .then((res) => {
          dispatch({
            type: types.EDIT_USER,
            payload: res.data.data,
          });
          window.location = "/clients";
        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error(error.response);
            dispatch({ type: types.RESET_LOADING });
          } else {
             toast.error(error.response);
             dispatch({ type: types.RESET_LOADING });
          }
        });
    } catch (err) {
      dispatch({ type: types.SET_ERROR });
       toast.error("axios error", err.message.data.error);
    }
  };
  

export const syncClientInformation = info => async (dispatch) => {


    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .post(`${baseUrl}/auth/sync`, info, axiosHeader(info.token))
        .then((res) => {
          dispatch({
            type: types.SYNC_USER,
            payload: res.data.data,
          });

          // window.location = "/clients";
          toast.success('Clinet information synced.');

        })
        .catch((error) => {
          if (error.response === undefined) {
            dispatch({ type: types.RESET_LOADING });
          } else {
              toast.error(error.response);
              dispatch({ type: types.RESET_LOADING });
          }
        });
    } catch (err) {
      dispatch({ type: types.SET_ERROR });
        toast.error("axios error", err.message.data.error);
    }
  };
  